/**
 * feat-354-auto-copy-lessons — on-screen copy for the "Copy of <original>" label on
 * auto-copied Lessons (design/NOTES.md §2). Grep here, not in the JSX.
 *
 * Read the two API fields through {@link copyOfInfo}: it is the single place that
 * decides original / copy-with-live-original / copy-of-a-deleted-lesson (CONTRACT C2).
 */
import type { QuizUnit } from '../../../services/quizContentAdminService';

/** Tree-row chip text. Not "Copied", not "Copy of …" — the full text is the tooltip. */
export const COPY_CHIP_LABEL = 'Copy';
/** Detail-line lead; never truncates. */
export const COPY_OF_LEAD = 'Copy of';
/** Copy whose original was deleted (no FK; the id dangles, the title is null). */
export const COPY_OF_DELETED = 'Copy of a deleted lesson';
/** Tree chip `title` (raw title, no quotes). */
export const copyOfTitle = (originalTitle: string) => `Copy of ${originalTitle}`;
/** Detail link `title` (curly quotes). */
export const openOriginalTitle = (originalTitle: string) => `Open “${originalTitle}”`;

export type CopyOfInfo =
  | { kind: 'original' }
  | { kind: 'copy'; originalId: string; originalTitle: string }
  | { kind: 'deleted'; originalId: string };

/** Absent fields (older backend) ⇒ original. */
export function copyOfInfo(unit: Pick<QuizUnit, 'copied_from_lesson_id' | 'copied_from_lesson_title'>): CopyOfInfo {
  const id = unit.copied_from_lesson_id;
  if (!id) return { kind: 'original' };
  const title = unit.copied_from_lesson_title;
  if (title == null) return { kind: 'deleted', originalId: id };
  return { kind: 'copy', originalId: id, originalTitle: title };
}
